module.exports = __webpack_public_path__ + "static/media/SM-ST1-TRIAL-if-correct.bec8735b.mp3";